import React from "react";
import { bool, node, oneOf, string } from "prop-types";
import { Row } from "../Grid";
import { spacingClassName, spacingProps, spacingPropTypes } from "../props/spacing";
import { classes } from "../utils/classes";

const Tabs = ({
	tabsID = "",
	tabsType = 1,
	isBorderBottom = true,
	spacing = { ...spacingProps },
	className = "",
	children,
	...props
}) => {
	return (
		<Row
			id={tabsID}
			className={classes(
				`tabs-v${tabsType}`,
				isBorderBottom && `tabs-v${tabsType}--border-bottom`,
				...spacingClassName(spacing),
				className,
			)}
			role="tablist"
			{...props}
		>
			{children}
		</Row>
	);
};

Tabs.propTypes = {
	isBorderBottom: bool,
	tabsType: oneOf([1, 2]),
	tabsID: string,
	className: string,
	spacing: spacingPropTypes,
	children: node.isRequired,
};

export default Tabs;
